export const categories = [
  {
    slug: 'dongzuo',
    name: '动作片',
    icon: 'ri-sword-line',
    description: '精彩刺激的动作电影，拳拳到肉的打斗场面，震撼的视觉特效',
  },
  {
    slug: 'xiju',
    name: '喜剧片',
    icon: 'ri-emotion-laugh-line',
    description: '轻松幽默的喜剧佳作，笑料不断，放松心情的最佳选择',
  },
  {
    slug: 'aiqing',
    name: '爱情片',
    icon: 'ri-heart-line',
    description: '浪漫动人的爱情故事，感人至深的情感演绎',
  },
  {
    slug: 'kehuan',
    name: '科幻片',
    icon: 'ri-rocket-line',
    description: '脑洞大开的科幻巨制，探索未知世界与未来科技',
  },
  {
    slug: 'kongbu',
    name: '恐怖片',
    icon: 'ri-ghost-line',
    description: '惊悚刺激的恐怖电影，挑战你的胆量极限',
  },
  {
    slug: 'donghua',
    name: '动画片',
    icon: 'ri-movie-line',
    description: '制作精良的动画作品，适合全年龄段观众欣赏',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-camera-line',
    description: '真实记录的纪录片，探索自然、历史与人文的奥秘',
  },
  {
    slug: 'dianshiju',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门电视剧全集，追剧不等待，一次看过瘾',
  },
];

export const allVideos = [
  {
    id: 1,
    title: '烈火英雄',
    category: 'dongzuo',
    year: 2019,
    rating: 8.5,
    duration: '120分钟',
    director: '陈国辉',
    cast: ['黄晓明', '杜江', '谭卓', '杨紫'],
    description: '滨海市海港码头发生管道爆炸，整个罐区的原油都顺着A01油罐往外流，化成火海和阵阵爆炸，威胁全市、全省，甚至邻国的安全。慌乱的市民们四处奔逃，一辆辆消防车却逆向冲进火海……',
    type: 'movie',
    featured: true,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Epic%20firefighter%20action%20movie%20poster%20with%20intense%20flames%20and%20smoke%2C%20dramatic%20warm%20orange%20and%20red%20tones%2C%20heroic%20silhouette%20against%20fire%2C%20cinematic%20film%20poster%20style%2C%20dark%20moody%20background%2C%20professional%20movie%20poster%20design%20with%20grain%20texture&width=400&height=560&seq=movie-liehuo-yingxiong&orientation=portrait',
  },
  {
    id: 2,
    title: '流浪地球2',
    category: 'kehuan',
    year: 2023,
    rating: 9.1,
    duration: '173分钟',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢'],
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    type: 'movie',
    featured: true,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Sci%20fi%20movie%20poster%20with%20earth%20in%20space%20and%20massive%20engines%2C%20futuristic%20technology%2C%20deep%20blue%20and%20silver%20tones%2C%20cinematic%20lighting%2C%20professional%20movie%20poster%20design%2C%20epic%20scale%2C%20dramatic%20composition%2C%20dark%20space%20background&width=400&height=560&seq=movie-liulang-diqi2&orientation=portrait',
  },
  {
    id: 3,
    title: '你好，李焕英',
    category: 'xiju',
    year: 2021,
    rating: 9.0,
    duration: '128分钟',
    director: '贾玲',
    cast: ['贾玲', '张小斐', '沈腾', '陈赫'],
    description: '2001年的某一天，刚刚考上大学的贾晓玲经历了人生中的一次大起大落。一心想要成为母亲骄傲的她却因母亲突遭严重意外而悲痛万分。在情绪崩溃的状态下，贾晓玲竟意外穿越到了1981年，与年轻的母亲李焕英相遇……',
    type: 'movie',
    featured: true,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20Chinese%20comedy%20drama%20movie%20poster%20with%20mother%20and%20daughter%2C%20vintage%201980s%20aesthetic%2C%20soft%20warm%20lighting%2C%20gentle%20cream%20and%20peach%20tones%2C%20emotional%20and%20heartwarming%2C%20minimalist%20poster%20design%2C%20film%20grain%20texture&width=400&height=560&seq=movie-nihao-lihuanying&orientation=portrait',
  },
  {
    id: 4,
    title: '长津湖',
    category: 'dongzuo',
    year: 2021,
    rating: 9.2,
    duration: '176分钟',
    director: '陈凯歌 / 徐克 / 林超贤',
    cast: ['吴京', '易烊千玺', '段奕宏', '朱亚文'],
    description: '1950年，中国志愿军部队与美军在朝鲜长津湖地区交战，中国人民志愿军第9兵团将美军1个多师分割包围于长津湖地区，歼敌1.3万余人，扭转了战场态势。这次战役中，中国人民志愿军凭着钢铁意志和英勇无畏的战斗精神，征服了极度恶劣的环境。',
    type: 'movie',
    featured: true,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Epic%20war%20movie%20poster%20with%20soldiers%20in%20snowy%20mountain%20battlefield%2C%20heroic%20military%20scene%2C%20cold%20winter%20atmosphere%2C%20dramatic%20contrast%20lighting%2C%20professional%20cinematic%20poster%20design%2C%20dark%20moody%20tones%20with%20white%20snow%20accents&width=400&height=560&seq=movie-changjinhu&orientation=portrait',
  },
  {
    id: 5,
    title: '满江红',
    category: 'dongzuo',
    year: 2023,
    rating: 8.8,
    duration: '159分钟',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这场巨大阴谋之中……',
    type: 'movie',
    featured: false,
    isNew: true,
    posterUrl: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20movie%20poster%20with%20ancient%20palace%20courtyard%2C%20Song%20dynasty%20aesthetic%2C%20deep%20red%20and%20black%20color%20palette%2C%20mysterious%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20film%20poster%20design%2C%20minimalist%20composition&width=400&height=560&seq=movie-manjianghong&orientation=portrait',
  },
  {
    id: 6,
    title: '独行月球',
    category: 'xiju',
    year: 2022,
    rating: 8.3,
    duration: '122分钟',
    director: '张吃鱼',
    cast: ['沈腾', '马丽', '黄才伦', '常远'],
    description: '人类为抵御小行星撞击，在月球部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因为意外错过了领队马蓝星的撤离通知，一个人落在了月球。不料月盾计划失败，独孤月成为了"宇宙最后的人类"……',
    type: 'movie',
    featured: false,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Sci%20fi%20comedy%20movie%20poster%20with%20astronaut%20alone%20on%20moon%20surface%2C%20lunar%20landscape%2C%20humorous%20tone%2C%20silver%20and%20gray%20color%20scheme%2C%20cinematic%20lighting%2C%20professional%20movie%20poster%20design%2C%20clean%20composition&width=400&height=560&seq=movie-duxing-yueqiu&orientation=portrait',
  },
  {
    id: 7,
    title: '封神第一部',
    category: 'dongzuo',
    year: 2023,
    rating: 8.9,
    duration: '148分钟',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适'],
    description: '商王殷寿与狐妖妲己勾结，暴虐无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主，以救苍生。西伯侯之子姬发逐渐发现殷寿的本来面目，反出朝歌……',
    type: 'movie',
    featured: true,
    isNew: true,
    posterUrl: 'https://readdy.ai/api/search-image?query=Mythological%20Chinese%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20epic%20scale%2C%20gold%20and%20crimson%20tones%2C%20dramatic%20cinematic%20lighting%2C%20professional%20movie%20poster%20design%2C%20ornate%20ancient%20Chinese%20aesthetic&width=400&height=560&seq=movie-fengshen-1&orientation=portrait',
  },
  {
    id: 8,
    title: '人生大事',
    category: 'xiju',
    year: 2022,
    rating: 8.7,
    duration: '112分钟',
    director: '刘江江',
    cast: ['朱一龙', '杨恩又', '王戈', '刘陆'],
    description: '殡葬师莫三妹在刑满释放不久后的一次出殡中，遇到了孤儿武小文。小文的出现，意外地改变了莫三妹对职业和生活的态度。',
    type: 'movie',
    featured: false,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20drama%20comedy%20movie%20poster%20with%20man%20and%20little%20girl%2C%20warm%20natural%20lighting%2C%20soft%20green%20and%20cream%20tones%2C%20emotional%20connection%2C%20professional%20film%20poster%20design%2C%20tender%20atmosphere%2C%20minimalist%20composition&width=400&height=560&seq=movie-rensheng-dashi&orientation=portrait',
  },
  {
    id: 9,
    title: '三体',
    category: 'dianshiju',
    year: 2023,
    rating: 8.7,
    duration: '30集',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    description: '2007年，地球基础科学出现了异常的扰动，一时间科学界风雨飘飘，人心惶惶。纳米科学家汪淼被警官史强带到联合作战中心，并潜入名为"科学边界"的组织协助调查。汪淼眼前出现了神秘的倒计时，并发现一款名为"三体"的游戏……',
    type: 'tv',
    featured: true,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Sci%20fi%20TV%20series%20poster%20with%20cosmic%20mystery%20theme%2C%20three%20suns%20in%20sky%2C%20dark%20blue%20and%20silver%20tones%2C%20mysterious%20atmosphere%2C%20minimalist%20design%2C%20professional%20series%20poster%2C%20dramatic%20cosmic%20lighting&width=400&height=560&seq=tv-san-ti&orientation=portrait',
  },
  {
    id: 10,
    title: '狂飙',
    category: 'dianshiju',
    year: 2023,
    rating: 9.3,
    duration: '39集',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合公检法司各部门，清除了政法队伍内部的腐败分子……',
    type: 'tv',
    featured: true,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20TV%20series%20poster%20with%20police%20and%20underworld%20theme%2C%20dark%20urban%20atmosphere%2C%20high%20contrast%20lighting%2C%20gritty%20aesthetic%2C%20professional%20series%20poster%20design%2C%20black%20and%20red%20color%20scheme%2C%20tense%20mood&width=400&height=560&seq=tv-kuangbiao&orientation=portrait',
  },
  {
    id: 11,
    title: '漫长的季节',
    category: 'dianshiju',
    year: 2023,
    rating: 9.4,
    duration: '12集',
    director: '辛爽',
    cast: ['范伟', '秦昊', '陈明昊', '李庚希'],
    description: '20世纪90年代，东北小镇桦林，一个少年离奇死亡，牵出了几个家庭之间长达近二十年的纠葛。出租车司机王响和妹夫龚彪在调查套牌车的过程中，与当年的案件产生了千丝万缕的联系……',
    type: 'tv',
    featured: false,
    isNew: true,
    posterUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20mystery%20TV%20series%20poster%20with%201990s%20northeast%20China%20setting%2C%20autumn%20atmosphere%2C%20warm%20amber%20and%20brown%20tones%2C%20melancholic%20mood%2C%20professional%20series%20poster%20design%2C%20vintage%20film%20aesthetic&width=400&height=560&seq=tv-manchang-jijie&orientation=portrait',
  },
  {
    id: 12,
    title: '铃芽之旅',
    category: 'donghua',
    year: 2023,
    rating: 8.5,
    duration: '121分钟',
    director: '新海诚',
    cast: ['原菜乃华', '松村北斗', '深津绘里'],
    description: '生活在日本九州田舍的17岁少女铃芽遇见了为了寻找"门"而踏上旅途的青年。追随着青年的脚步，铃芽来到了山上一片废墟之地，在这里静静伫立着一扇古老的门，仿佛是坍塌中存留的唯一遗迹。铃芽仿佛被什么吸引了一般，将手伸向了那扇门……',
    type: 'movie',
    featured: false,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20with%20Japanese%20countryside%20girl%20and%20mystical%20door%2C%20beautiful%20sky%20with%20clouds%2C%20soft%20blue%20and%20pink%20tones%2C%20dreamy%20atmosphere%2C%20anime%20film%20poster%20style%2C%20clean%20composition%2C%20emotional%20and%20scenic&width=400&height=560&seq=movie-lingya-zhilv&orientation=portrait',
  },
  {
    id: 13,
    title: '消失的她',
    category: 'kongbu',
    year: 2023,
    rating: 8.3,
    duration: '121分钟',
    director: '陈思诚',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    description: '东南亚某国，年轻男子何非疯狂寻找失踪的妻子李木子。然而当地警局视若罔闻，令他出离愤怒。就在某个清晨，何非突然发现身边躺着一名陌生女子，更令他毛骨悚然的是，女子居然声称是他的妻子李木子……',
    type: 'movie',
    featured: false,
    isNew: true,
    posterUrl: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20with%20mysterious%20tropical%20island%20vibe%2C%20disappearance%20theme%2C%20dark%20turquoise%20and%20black%20tones%2C%20tense%20atmosphere%2C%20professional%20film%20poster%20design%2C%20minimalist%20with%20sense%20of%20danger&width=400&height=560&seq=movie-xiaoshi-data&orientation=portrait',
  },
  {
    id: 14,
    title: '深海',
    category: 'donghua',
    year: 2023,
    rating: 8.4,
    duration: '112分钟',
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文', '滕奎兴'],
    description: '在大海的最深处，藏着所有秘密。一位现代少女参宿误入梦幻的深海世界，却因此邂逅了一段独特的生命旅程。',
    type: 'movie',
    featured: false,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20with%20dreamy%20deep%20ocean%20world%2C%20colorful%20underwater%20creatures%2C%20vibrant%20blue%20and%20purple%20gradients%2C%20magical%20atmosphere%2C%20Chinese%20animation%20style%2C%20professional%20film%20poster%20design%2C%20ethereal%20lighting&width=400&height=560&seq=movie-shenhai&orientation=portrait',
  },
  {
    id: 15,
    title: '宇宙探索编辑部',
    category: 'kehuan',
    year: 2023,
    rating: 8.6,
    duration: '118分钟',
    director: '孔大山',
    cast: ['杨皓宇', '艾丽娅', '王一通', '蒋奇明'],
    description: '唐志军是一家诞生于上世纪八十年代的科幻杂志《宇宙探索》编辑部的主编。现如今的杂志社日渐式微，唐志军也终成落魄潦倒、鳏寡孤独之人。但他却依然几十年如一日的痴迷于寻找地外文明……',
    type: 'movie',
    featured: false,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Quirky%20sci%20fi%20mockumentary%20movie%20poster%20with%20retro%20UFO%20and%20alien%20theme%2C%20vintage%201980s%20aesthetic%2C%20warm%20sepia%20and%20green%20tones%2C%20humorous%20and%20eccentric%20mood%2C%20professional%20film%20poster%20design%2C%20minimalist%20composition&width=400&height=560&seq=movie-yuzhou-tansuo&orientation=portrait',
  },
  {
    id: 16,
    title: '我爱你！',
    category: 'aiqing',
    year: 2023,
    rating: 8.7,
    duration: '116分钟',
    director: '韩延',
    cast: ['倪大红', '惠英红', '梁家辉', '叶童'],
    description: '空巢老人常为戒和拾废品的孤寡老太李慧如不打不相识，却渐渐互生情愫；年迈的谢定山和赵欢欣夫妻俩靠收卖废品为生，妻子赵欢欣更是一直深受疾病的困扰……四位老人，两对爱人，在步入生命终章之时，他们用力而纯粹地相爱。',
    type: 'movie',
    featured: false,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20with%20elderly%20couple%20holding%20hands%2C%20warm%20sunset%20lighting%2C%20soft%20rosy%20and%20golden%20tones%2C%20tender%20and%20emotional%20atmosphere%2C%20professional%20film%20poster%20design%2C%20minimalist%20and%20elegant&width=400&height=560&seq=movie-woaini&orientation=portrait',
  },
  {
    id: 17,
    title: '航拍中国',
    category: 'jilupian',
    year: 2022,
    rating: 9.2,
    duration: '四季共34集',
    director: '余乐',
    cast: [],
    description: '以空中视角俯瞰中国，立体化展示我国历史人文景观、自然地理风貌及经济社会发展，全景式俯瞰一个观众既熟悉又新鲜的美丽中国、生态中国、文明中国。',
    type: 'tv',
    featured: true,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Aerial%20documentary%20series%20poster%20with%20stunning%20bird%20eye%20view%20of%20Chinese%20landscapes%2C%20mountains%20and%20rivers%20from%20above%2C%20vibrant%20green%20and%20blue%20natural%20colors%2C%20professional%20documentary%20poster%20design%2C%20epic%20scale%2C%20clean%20aerial%20photography%20style&width=400&height=560&seq=doc-hangpai-zhongguo&orientation=portrait',
  },
  {
    id: 18,
    title: '孤注一掷',
    category: 'kongbu',
    year: 2023,
    rating: 8.6,
    duration: '130分钟',
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君'],
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现并完成业绩……',
    type: 'movie',
    featured: false,
    isNew: true,
    posterUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20online%20scam%20theme%2C%20dark%20underground%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20tense%20and%20dangerous%20mood%2C%20professional%20film%20poster%20design%2C%20gritty%20urban%20aesthetic&width=400&height=560&seq=movie-guzhu-yizhi&orientation=portrait',
  },
  {
    id: 19,
    title: '热烈',
    category: 'xiju',
    year: 2023,
    rating: 8.4,
    duration: '124分钟',
    director: '大鹏',
    cast: ['黄渤', '王一博', '刘敏涛', '岳云鹏'],
    description: '街舞老炮儿丁雷偶遇卖艺少年陈烁，丁雷忽悠陈烁加入自己经营的舞团。舞团内高手如云，性格各异，与陈烁碰撞出不同的火花，笑料不断。',
    type: 'movie',
    featured: false,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Dance%20comedy%20movie%20poster%20with%20street%20dance%20energy%2C%20dynamic%20movement%2C%20vibrant%20orange%20and%20yellow%20tones%2C%20youthful%20and%20energetic%20vibe%2C%20professional%20film%20poster%20design%2C%20urban%20street%20style%2C%20exciting%20atmosphere&width=400&height=560&seq=movie-relie&orientation=portrait',
  },
  {
    id: 20,
    title: '长安三万里',
    category: 'donghua',
    year: 2023,
    rating: 9.0,
    duration: '168分钟',
    director: '谢君伟 / 邹靖',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事……',
    type: 'movie',
    featured: true,
    isNew: false,
    posterUrl: 'https://readdy.ai/api/search-image?query=Historical%20animated%20movie%20poster%20with%20Tang%20dynasty%20Chang%20an%20cityscape%2C%20ancient%20Chinese%20poetry%20theme%2C%20golden%20and%20crimson%20tones%2C%20elegant%20classical%20aesthetic%2C%20professional%20animated%20film%20poster%20design%2C%20majestic%20composition&width=400&height=560&seq=movie-changan-sanwanli&orientation=portrait',
  },
];

export const sortOptions = [
  { value: 'default', label: '默认排序' },
  { value: 'rating', label: '评分最高' },
  { value: 'year', label: '最新上映' },
];

export const aboutInfo = {
  brandIntro:
    '农民影视成立于2018年，是国内领先的免费高清在线影视平台。我们致力于为广大影视爱好者提供最全面、最优质的观影体验。平台汇聚了海量正版影视资源，涵盖电影、电视剧、动画、纪录片等多种类型，以满足不同用户的多样化需求。',
  mission:
    '让每一个人都能轻松享受高清影视的魅力，是农民影视始终不变的使命。我们持续优化播放技术，确保流畅不缓冲的观影体验，同时不断扩充片库，让用户总能找到想看的内容。',
  values: [
    {
      title: '片库丰富',
      description: '收录超10万部影视作品，涵盖国内外热门电影、电视剧、综艺、动漫、纪录片等全品类内容。',
    },
    {
      title: '高清画质',
      description: '采用先进的视频编码技术，提供1080P至4K超高清画质，为用户带来影院级观影享受。',
    },
    {
      title: '流畅体验',
      description: '全球CDN加速节点覆盖，智能码率自适应技术，确保在不同网络环境下都能流畅播放不缓冲。',
    },
    {
      title: '免费观看',
      description: '坚持免费观影理念，所有影视资源均可免费在线观看，无需会员，无需付费。',
    },
  ],
  milestones: [
    { year: '2018', event: '农民影视平台正式上线，初始片库5000部' },
    { year: '2019', event: '片库突破2万部，月活跃用户突破100万' },
    { year: '2020', event: '全面升级播放技术，支持4K超高清画质' },
    { year: '2021', event: '推出智能推荐系统，个性化内容匹配度提升60%' },
    { year: '2022', event: '片库突破8万部，月活跃用户突破500万' },
    { year: '2023', event: '平台进行全面品牌升级，片库突破10万部' },
    { year: '2024', event: '荣获"最佳用户体验影视平台"称号，覆盖全终端设备' },
  ],
  contact: {
    email: 'service@nongminyingshi.com',
    phone: '400-888-6666',
    address: '北京市朝阳区建国路88号影视传媒大厦12层',
    wechat: '农民影视官方',
    weibo: '@农民影视',
  },
  testimonials: [
    {
      name: '王先生',
      avatar: 'W',
      role: '资深影迷',
      content: '农民影视是我用过最好的免费观影平台，片源丰富更新快，画质清晰不卡顿，强烈推荐！',
    },
    {
      name: '李女士',
      avatar: 'L',
      role: '家庭主妇',
      content: '每天晚上都会陪孩子一起在农民影视看动画片，分类清晰找片方便，孩子特别喜欢。',
    },
    {
      name: '张同学',
      avatar: 'Z',
      role: '大学生',
      content: '周末和室友一起刷剧必备！资源超全，热门新剧更新速度也很快，关键是免费！',
    },
    {
      name: '赵老师',
      avatar: 'Z',
      role: '中学教师',
      content: '经常在课堂上推荐纪录片给学生看，农民影视的纪录片资源很丰富，画质也很棒。',
    },
    {
      name: '陈先生',
      avatar: 'C',
      role: 'IT工程师',
      content: '作为技术人员，我特别欣赏农民影视的播放流畅度，技术团队真的很用心在做产品。',
    },
    {
      name: '刘阿姨',
      avatar: 'L',
      role: '退休职工',
      content: '操作简单界面清晰，我这个年纪也能轻松找到想看的电视剧，每天追剧成了最大的乐趣。',
    },
  ],
  faqs: [
    {
      question: '农民影视是否完全免费？',
      answer: '是的，农民影视对所有用户完全免费。您可以免费观看平台上的所有影视资源，无需支付任何费用，也不需要购买会员。我们通过广告收入来维持平台的运营。',
    },
    {
      question: '如何快速找到我想看的影视作品？',
      answer: '您可以通过首页顶部的搜索框输入关键词搜索，也可以通过分类页面按影片类型筛选。此外，首页的"精选推荐"和"最新上线"板块也会定期更新热门内容。',
    },
    {
      question: '为什么有些影片播放时会出现缓冲？',
      answer: '播放卡顿通常与您的网络环境有关。建议您检查网络连接状态，或尝试切换至较低画质。如问题持续存在，请联系客服反馈。',
    },
    {
      question: '农民影视支持哪些设备观看？',
      answer: '农民影视支持电脑、平板、手机等全终端设备。您可以通过浏览器直接访问我们的网站，无需下载任何APP，即可在任何设备上畅享观影体验。',
    },
    {
      question: '影片更新频率是怎样的？',
      answer: '我们的内容团队每天都会更新片库，热门电影和电视剧会在第一时间上线。通常在院线下映后1-3个月内即可在平台观看，电视剧则在首播后24小时内更新。',
    },
    {
      question: '如何联系农民影视的客服？',
      answer: '您可以通过以下方式联系我们：发送邮件至 service@nongminyingshi.com，拨打客服热线 400-888-6666（工作日9:00-18:00），或关注我们的微信公众号"农民影视官方"进行在线咨询。',
    },
  ],
};